// --------------------------------------------------------------
// Created On: 2021-05-14
// Author: Zachary Thomas
//
// Last Modified: 2026-10-15
// Modified By: Zachary Thomas
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import { Link } from "react-router-dom";
import styles from "./NavbarLink.module.scss";

// A single clickable link on a navbar.
export default function NavbarLink(props: Props): Component {
  const targetPage = props.targetPage ?? props.currentPage;

  // Treat partial matches as complete matches, unless exact is enabled.
  function isActive(targetPage: string, currentPage: string, exactMatch?: boolean): boolean {
    if (exactMatch) {
      return targetPage === currentPage;
    } else {
      const currentSubdirectories = currentPage.split("/");
      return targetPage.split("/").every((subdirectory, i) => currentSubdirectories[i] === subdirectory);
    }
  }

  return (
    <li
      className={`${styles.item} mx-3 ${
        isActive(targetPage, props.currentPage, props.exactMatch) ? styles.active : ""
      }`}
    >
      <Link className={styles.link} to={targetPage}>
        <span>{props.name}</span>
      </Link>
    </li>
  );
}

interface Props {
  name: string;
  currentPage: string;
  targetPage?: string;
  exactMatch?: boolean;
}
